import React, { useState, useEffect, Fragment } from "react";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import SaveeIcon from "@material-ui/icons/Save";
import PostAddIcon from "@material-ui/icons/PostAdd";
import { Delete } from "@material-ui/icons";
import { CircularProgress, CssBaseline, Grid } from "@material-ui/core";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStyles } from "../AccountsIndexes/account-index-style";
import { useStylesCAB } from "../../../../St/comps/UseStyle";

export default function AccountTreeApp(props) {
    const clasess = useStyles();
    const {
        prmis,
        handleSave,
        handleDelete,
        submitting,
        resetForm,
        mode,
    } = props;
    const { t } = useTranslation(["forms"]);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });

    const his = useHistory();
    const backHome = () => {
        his.goBack();
    };
    const clasCAB = useStylesCAB();

    return (
        <Fragment>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <CssBaseline />
            <AppBar
                // position="fixed"
                style={{
                    top: "auto",
                    bottom: 0,
                    backgroundColor: "#808080",
                }}
            >
                <Toolbar>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                        <Button
                            className={clasess.buttonss}
                            variant="contained"
                            color="primary"
                            fontSize="large"
                            size="medium"
                            onClick={backHome}
                            startIcon={<CancelIcon />}
                        >
                            {" "}
                            {t("exit")}
                        </Button>
                    </Grid>

                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                    ></IconButton>
                    <div className={clasess.grow} />
                    <div className={clasCAB.wrapperCAB} >
                        <IconButton color="inherit">
                            <Button
                                className={clasess.buttonss}
                                variant="contained"
                                color="secondary"
                                fontSize="large"
                                size="medium"
                                startIcon={<Delete />}
                                disabled={submitting || mode == "new" || prmis?.De}
                                onClick={() => {
                                    setConfirmDialog({
                                        isOpen: true,
                                        title: "؟هل تريد الحذف بالتأكيد",
                                        subTitle: "",
                                        onConfirm: () => {
                                            handleDelete();
                                        },
                                    });
                                }}
                            >
                                {" "}
                                {t("delete")}
                            </Button>
                        </IconButton>
                        {submitting && (
                            <CircularProgress
                                size={24}
                                className={clasCAB.buttonProgressCAB}
                            />
                        )}
                    </div>
                    <div className={clasCAB.wrapperCAB} >
                        <Button
                            className={clasess.buttonss}
                            variant="contained"
                            color="primary"
                            fontSize="large"
                            size="medium"
                            onClick={() => handleSave()}
                            startIcon={<SaveeIcon />}
                            disabled={submitting || (mode == "new" ? prmis?.Sa : prmis?.Up)}
                        >
                            {mode == "new" ? t("save") : t("save-update")}
                        </Button>
                        {submitting && (
                            <CircularProgress
                                size={24}
                                className={clasCAB.buttonProgressCAB}
                            />
                        )}
                    </div>
                    <Button
                        variant="contained"
                        edge="start"
                        color="primary"
                        fontSize="large"
                        className={clasess.buttonss}
                        startIcon={<PostAddIcon />}
                        onClick={() => resetForm()}
                    >
                        {t("new")}
                    </Button>
                </Toolbar>
            </AppBar>
        </Fragment>
    );
}
